module.exports = __webpack_public_path__ + "static/media/great_job_imag.3ceb03c8.png";